import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { IconTableRowElement } from "src/util/types/components/sfxTable"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"
import SfxTooltip from "../tooltip/SfxTooltip.vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableTdStatus',
  props: {
  icons: {
    type: Array as PropType<Array<IconTableRowElement>>,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables
const { t } = useI18n()
const columnData = computed(() => props.icons)

//endregion

//region Functions
function getColor(icon: IconTableRowElement) {
  return icon.color ?? "transparent"
}

function getToolTip(icon: IconTableRowElement): string {
  switch (icon.column) {
    case "work-order":
      return t("sfxTooltip.work_order")
    case "issue":
      return t("sfxTooltip.issue")
    case "change-request":
      return t("sfxTooltip.change_request")
    case "done":
      return t("sfxTooltip.done")
    case "corrective-work":
      return t("sfxTooltip.corrective_work")
    case "issue-overdue":
      return t("sfxTooltip.issue_overdue")
    case "corrective-work-accepted":
      return t("sfxTooltip.corrective_work_accepted")
    case "closed":
      return t("sfxTooltip.closed")
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_td = _resolveComponent("q-td")!

  return (_openBlock(), _createBlock(_component_q_td, { class: "sfx-table__td sfx-table__td-status text-center" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnData.value, (column, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!column.ignoreRendering)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: index,
                class: "q-px-xs",
                name: column.name,
                color: getColor(column),
                size: "20px"
              }, {
                default: _withCtx(() => [
                  (column.color !== undefined && column.color !== 'transparent')
                    ? (_openBlock(), _createBlock(SfxTooltip, {
                        key: 0,
                        data: { text: getToolTip(column), isHtml: true }
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["name", "color"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    _: 1
  }))
}
}

})